export const mockPrivateChats = [
    {
        id: 1,
        name: "Алексей Иванов",
        avatar: "А",
        status: "онлайн",
        lastMessage: "Привет! Как дела?",
        time: "14:30",
        unread: 2,
        messages: [
            { id: 1, text: "Привет! Как дела?", time: "14:30", sender: "Алексей Иванов", type: "incoming" },
            { id: 2, text: "Отлично, спасибо! А у тебя?", time: "14:31", sender: "Вы", type: "outgoing" },
            { id: 3, text: "Тоже хорошо. Завтра встречаемся?", time: "14:32", sender: "Алексей Иванов", type: "incoming" }
        ]
    },
    {
        id: 2,
        name: "Мария Смирнова",
        avatar: "М",
        status: "был(а) 5 мин назад",
        lastMessage: "Отправь фото, пожалуйста",
        time: "13:15",
        unread: 0,
        messages: [
            { id: 1, text: "Привет! Как прошел концерт?", time: "12:00", sender: "Мария Смирнова", type: "incoming" },
            { id: 2, text: "Отлично! Очень понравилось", time: "12:05", sender: "Вы", type: "outgoing" },
            { id: 3, text: "Отправь фото, пожалуйста", time: "13:15", sender: "Мария Смирнова", type: "incoming" }
        ]
    }
];

export const mockGroups = [
    {
        id: 1,
        name: "Разработчики",
        avatar: "Р",
        members: ["Алексей Иванов", "Мария Смирнова", "Дмитрий Петров", "Вы"],
        lastMessage: "Обновление версии завтра",
        time: "10:30",
        unread: 5,
        messages: [
            { id: 1, text: "Коллеги, привет!", time: "09:00", sender: "Алексей Иванов", type: "incoming" },
            { id: 2, text: "Всем привет! Как успехи?", time: "09:15", sender: "Мария Смирнова", type: "incoming" },
            { id: 3, text: "Почти закончили проект", time: "09:30", sender: "Вы", type: "outgoing" },
            { id: 4, text: "Обновление версии завтра", time: "10:30", sender: "Дмитрий Петров", type: "incoming" }
        ]
    },
    {
        id: 2,
        name: "Семья",
        avatar: "С",
        members: ["Мама", "Папа", "Сестра", "Вы"],
        lastMessage: "Ужин в 19:00",
        time: "Вчера",
        unread: 0,
        messages: [
            { id: 1, text: "Кто будет на ужине?", time: "Вчера 18:00", sender: "Мама", type: "incoming" },
            { id: 2, text: "Я буду", time: "Вчера 18:15", sender: "Вы", type: "outgoing" },
            { id: 3, text: "Ужин в 19:00", time: "Вчера 18:30", sender: "Папа", type: "incoming" }
        ]
    }
];
